module.exports = __webpack_public_path__ + "static/media/MojitoSwap.1b00f4eb.svg";